import React from 'react';
import { RadioGroup, RadioButton } from 'react-toolbox/lib/radio';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder

import styles from './SignupCategory.scss';

class Category extends React.Component {


  static propTypes = {
    onChange: PropTypes.func.isRequired,
  };
  static defaultProps = {
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = { value: 'STUDENT' };
  }

  handleChange = (value) => {
    this.setState({ value });
    this.props.onChange(value);
  };

  render() {
    return (
      <div className={cn('row', styles.container)}>
        <div className={cn('col s4')}>
          <RadioGroup name="comic" value={this.state.value} onChange={this.handleChange}>
            <RadioButton label="Athlete" value="STUDENT" />
          </RadioGroup>
        </div>
        {/* <div className={cn('col s4')}> */}
        {/* <RadioGroup name="comic" value={this.state.value} onChange={this.handleChange}> */}
        {/* <RadioButton label="Parent" value="PARENT" /> */}
        {/* </RadioGroup> */}
        {/* </div> */}
        <div className={cn('col s4')}>
          <RadioGroup name="comic" value={this.state.value} onChange={this.handleChange}>
            <RadioButton label="Coach" value="COACH" />
          </RadioGroup>
        </div>
      </div>
    );
  }
}


export default Category;



// WEBPACK FOOTER //
// ./src/components/SignupCategory/SignupCategory.js